import { services } from "@/mocks/homeData";

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-amber-300 text-amber-700 text-xs font-semibold tracking-widest uppercase mb-4">
            What We Offer
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Everything You Need to Reach the Top
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            From SAT prep to Ivy League admissions — our expert team covers every step of your college journey with personalized, results-driven programs.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className={`group relative rounded-2xl p-7 bg-gradient-to-br ${service.color} border border-gray-100 hover:shadow-md transition-all duration-300 cursor-pointer`}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-5 transition-colors duration-300"
                style={{ backgroundColor: `${service.accent}18` }}
              >
                <i
                  className={`${service.icon} text-2xl`}
                  style={{ color: service.accent }}
                ></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
              <div className="mt-5 flex items-center gap-1 text-sm font-semibold" style={{ color: service.accent }}>
                <span>Learn more</span>
                <i className="ri-arrow-right-line text-base"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
